<div class="container">
  <div>
    <p-carousel class="content" [value]="eventos" [numVisible]="4" [numScroll]="4" [circular]="false"
      [responsiveOptions]="responsiveOptions">
      <ng-template let-evento pTemplate="item">
        <div class="carde">
          <div class="img-container">
            <img [src]="evento.imagem" [alt]="evento.nome" class="evento-img" />
            <div class="overlay">
              <div class="text">
                <span class="evento-horario">{{ evento.horario }}</span>
                <span class="evento-titulo">{{ evento.nome }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </p-carousel>
  </div>
</div>